<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :destroyOnClose="true" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        理解题
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="题干">
            <a-textarea style="width: 80%" v-model="drill.text" placeholder="请输入题干"/>
          </a-form-model-item>
          <a-form-model-item label="题干音频">
            <AudioUpload :defaultUrl="drill.audioUrl ? `${drill.audioUrl}`: undefined" @changeUri="changeAudioUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="题干视频">
            <VideoUpload :defaultUrl="drill.videoUrl ? `${drill.videoUrl}`: undefined" @changeUri="changeVideoUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="题图">
            <CommonUpload :defaultUrl="this.drill.imageUrl ? `${this.drill.imageUrl}`: undefined" @changeImgUri="changeImgUri" path="img/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="小题">
            <a-row v-for="(question, questionIndex) in drill.questionList" :key="questionIndex" style="margin-top: 32px;">
              <a-row>
                
                <a-col span="2">
                  <a-icon
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    @click="removeQuestion(questionIndex)"/>
                  {{ questionIndex + 1 }}小题、
                </a-col>
                <a-col span="14">
                  <a-textarea style="width: 100%" v-model="question.text" :placeholder="`请输入${questionIndex + 1}小题题干`"/>
                  <a-row v-for="(option, optionIndex) in question.correctAnswer" :key="optionIndex">
                    <span>{{ optionIndex + 1 }}. </span>
                    <a-input style="width: 60%" v-model="question.correctAnswer[optionIndex]" placeholder="请输入选项文字"/>
                    <a-icon
                      v-if="question.correctAnswer.length > 1"
                      class="dynamic-delete-button"
                      type="minus-circle-o"
                      @click="removeOption(questionIndex, optionIndex)"/>
                  </a-row>
                  <a-button type="dashed" style="width: 100%" @click="() => addOption(questionIndex)">
                    <a-icon type="plus" />增加选项
                  </a-button>
                  <a-textarea style="width: 100%" v-model="question.explanation" :placeholder="`解析`"/>
                </a-col>
              </a-row>
            </a-row>
          </a-form-model-item>
          <a-form-model-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 80%" @click="addQuestion">
              <a-icon type="plus" />增加小题
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import PassageSequencingDrillApi from '../../../../api/src/drill/api/PassageSequencingDrillApi.js'
const passageSequencingDrillApi = new PassageSequencingDrillApi()
import CommonUpload from '../../../../components/CommonUpload.vue'
import AudioUpload from '../../../../components/AudioUpload.vue'
import VideoUpload from '../../../../components/VideoUpload.vue'
import { deepClone } from '@clownlee/utils'

export default {
  name: "PassageSequencingDrillEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {CommonUpload, AudioUpload, VideoUpload},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await passageSequencingDrillApi.getDetail(this.currentDrillId)
        console.log(resp)
        this.drill = resp
        this.loading = false
        return
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        required: false,
        text: undefined,
        imageUri: undefined,
        audioUri: undefined,
        videoUri: undefined,
        questionList: [],
        explanation: undefined,
      },
      loading: false,
      visible: false
    }
  },
  methods:{
    async changeAudioUri(uri) {
      this.drill.audioUri = uri
    },
    async changeVideoUri(uri) {
      this.drill.videoUri = uri
    },
    addQuestion() {
      let questionList = deepClone(this.drill.questionList)
      questionList.push({
        text: undefined,
        explanation: undefined,
        imageUrl: undefined,
        imageUri: undefined,
        correctAnswer: [],
        optionList: []
      })
      this.drill.questionList = questionList
    },
    removeOption(questionIndex, optionIndex) {
      let questionList = deepClone(this.drill.questionList)
      questionList[questionIndex].correctAnswer.splice(optionIndex, 1)
      this.drill.questionList = questionList
    },
    addOption(questionIndex) {
      let questionList = deepClone(this.drill.questionList)
      questionList[questionIndex].correctAnswer.push('')
      this.drill.questionList = questionList
    },
    removeQuestion(questionIndex) {
      let questionList = deepClone(this.drill.questionList)
      questionList.splice(questionIndex, 1)
      this.drill.questionList = questionList
    },


    changeImgUri(uri) {
      this.drill.imageUri = uri
      console.log(uri)
    },
    changeOptionImgUri(index, uri) {
      console.log(index, uri)
      this.drill.optionList[index].imageUri = uri
    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        imageUri: undefined,
        audioUri: undefined,
        videoUri: undefined,
        questionList: [],
        explanation: undefined,
      }
    },
    async handleOk() {
      console.log(this.drill)
      let drill = deepClone(this.drill)
      if(!drill.text){
        this.$message.error('请填写题干')
        return
      }
      if(!drill.questionList || drill.questionList.length == 0) {
        this.$message.error('请增加小题')
        return
      }
      let correctAnswer = []
      for(let i = 0; i < drill.questionList.length; i++){
        if(!drill.questionList[i].text){
          this.$message.error(`请填写${i + 1}小题题干`)
          return
        }
        // 检查题干中"[]"的数量必须与选项数量相同
        const bracketMatches = drill.questionList[i].text.match(/\[\]/g);
        const bracketCount = bracketMatches ? bracketMatches.length : 0;
        if(bracketCount !== drill.questionList[i].correctAnswer.length){
          this.$message.error(`第${i + 1}小题题干中"[]"的数量(${bracketCount})必须与选项数量(${drill.questionList[i].correctAnswer.length})相同`)
          return
        }
        let optionList = []
        for(let j = 0; j < drill.questionList[i].correctAnswer.length; j++){
          if(!drill.questionList[i].correctAnswer[j]){
            this.$message.error(`请填写${i + 1}小题第${j + 1}个选项`)
            return
          }
        }
        // 强制打乱小题的 correctAnswer 生成 optionList，原数组顺序将会被直接打乱
        let shuffled = drill.questionList[i].correctAnswer.slice();
        for (let k = shuffled.length - 1; k > 0; k--) {
          const randIdx = Math.floor(Math.random() * (k + 1));
          [shuffled[k], shuffled[randIdx]] = [shuffled[randIdx], shuffled[k]];
        }
        drill.questionList[i].optionList = shuffled;
        correctAnswer.push(drill.questionList[i].correctAnswer)
        console.log(drill.questionList[i].correctAnswer)
        console.log(drill.questionList[i].optionList)
      }
      drill.correctAnswer = correctAnswer
      if(!drill.id){
        drill.subType = this.subType
      }
      console.debug(drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!drill.id){
        await passageSequencingDrillApi.create(drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await passageSequencingDrillApi.update(drill.id, drill)
      }
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        imageUri: undefined,
        audioUri: undefined,
        videoUri: undefined,
        questionList: [],
        explanation: undefined,
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    },
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>